/**
 * Project : workspace
 * File    : main.kt
 * Created : AUTO-GENERATED by scripts/add_kdoc.py
 */

package com.parmartechnologies

import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.unit.dp
import androidx.compose.ui.window.ComposeViewport
import androidx.navigation.ExperimentalBrowserHistoryApi
import androidx.navigation.bindToNavigation
import appConfig.AppConfig
import com.parmartechnologies.core.navigation.NavigationParam
import com.parmartechnologies.storage.database.AppDatabase
import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.Job
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import kotlinx.serialization.ExperimentalSerializationApi
import navigation.AppNavigator
import navigation.business.window.BusinessAppWindow
import navigation.commerce.route.home.CommerceHomeNavRoute
import org.jetbrains.skiko.wasm.onWasmReady
import org.w3c.dom.Window

@OptIn(
    ExperimentalComposeUiApi::class, ExperimentalBrowserHistoryApi::class,
    ExperimentalSerializationApi::class
)
        /**
         * Executes the main operation.
         *
         * @receiver TODO
         * @return Unit – no return value.
         */
fun main() {
    val mainScope = CoroutineScope(Job() + Dispatchers.Default)
    onWasmReady {
        AppNavigator.shared().screenWidth = window.outerWidth.dp
        AppNavigator.shared().screenHeight = window.outerHeight.dp
        AppDatabase.window = window
        AppDatabase.shared().createDb("prd")
        val url = window.location.hash
        val initRoute = url.substringAfter('#', "").substringBefore("?")
        var home = ""
        if (initRoute == CommerceHomeNavRoute.STORES) {
            home = initRoute
        } else if (url.contains("business") || url.contains("localhost")) {
            home = initRoute
        }
        console.log("initRoute = $initRoute")
        val navParam = getNavParam(window)
        console.log("getNavParam = JSON.stringify($navParam);")
        if (navParam != null) {
            AppNavigator.shared().setParam(initRoute, navParam)
        } else {
//            window.alert("null param")
        }
        ComposeViewport(document.body!!) {
            BusinessAppWindow(home).content {
                window.bindToNavigation(it)
                mainScope.launch {
                    delay(1000)
                    AppNavigator.shared().navigate(initRoute, navParam)
                }
            }
        }
        window.document.title = AppConfig.shared().appName
    }
}

/**
 * Executes the get nav param operation.
 *
 * @receiver TODO
 * @param window The window.
 * @return The resulting navigation param?.
 */

fun getNavParam(window: Window): NavigationParam? {
    var result = ""
    val paramStr = window.location.hash.split("?")
    val params = paramStr.last().split("=")
    if (params.count() == 2) {
        result = params.last()
    }
    console.log("params = $result")
    if (result.isNotEmpty()) {
        val param = NavigationParam()
        param._id = result
        return param
    } else {
        return null
    }
}